import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/owlBranding/instructorBannerPhilosophy.webp'

export const InstructorBannerPhilosophy: React.FC<
    unknown
> = (): ReactElement => <Image src={src} alt={'instructor banner'} />
